import Immutable from 'immutable';

const StudentGeneralInfoRecord = Immutable.Record({
  id: undefined,
  firstName: undefined,
  lastName: undefined,
  localName: undefined,
  studentNumber: undefined,
  avatarUrl: undefined,
  gender: undefined,
});

export default class StudentGeneralInfo extends StudentGeneralInfoRecord { }



// WEBPACK FOOTER //
// ./data/AcademicInfo/StudentGeneralInfo/model.js